export function normalizeSeasonCodeForOrderMatch(seasonCode: string | undefined | null): string {
    if (seasonCode === undefined || seasonCode === null || String(seasonCode).trim() === '') {
        return 'Unknown';
    }
    return String(seasonCode).trim();
}

/**
 * Whether a product season is allowed on the active order type (same rule as AddItemToOrder).
 * allowedSeasons null/undefined = restriction not active (fail open).
 */
export function seasonAllowedForOrder(
    seasonCode: string | undefined | null,
    allowedSeasons: string[] | null | undefined
): boolean {
    if (allowedSeasons === null || allowedSeasons === undefined) {
        return true;
    }
    if (!allowedSeasons.length) {
        return false;
    }
    const normalized = normalizeSeasonCodeForOrderMatch(seasonCode);
    return allowedSeasons.some((code) => code === normalized);
}

export function partitionSeasonCodesByOrderMatch(
    orderedSeasonCodes: string[],
    allowedSeasons: string[] | null | undefined
): string[] {
    if (allowedSeasons === null || allowedSeasons === undefined) {
        return orderedSeasonCodes;
    }
    const matching: string[] = [];
    const nonMatching: string[] = [];
    for (const code of orderedSeasonCodes) {
        if (seasonAllowedForOrder(code, allowedSeasons)) {
            matching.push(code);
        } else {
            nonMatching.push(code);
        }
    }
    return matching.concat(nonMatching);
}
